<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="30%"
    :show-close="false"
    :close-on-click-modal="false"
    @closed="dialogClose"
  >
    <el-progress
      :percentage="percentage"
      :status="statuses[statusIndex]"
    ></el-progress>
    <span slot="footer" class="dialog-footer">
      <el-button
        :disabled="disabled && percentage < 100"
        :loading="disabled && percentage < 100"
        :type="statusIndex === 1 ? 'danger' : 'primary'"
        @click="submit"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
/**
 * 进度监控组件
 */
export default {
  name: 'loading-dialog',
  data: () => {
    return {
      // 确定按钮是否生效
      disabled: false,
      // 当前进度
      percentage: 0,
      // 请求进度数据函数
      progressOn: () => {},
      statuses: [null, 'exception', 'success'],
      statusIndex: 0,
      counter: 0
    }
  },
  mounted() {
    if (this.percentFn) {
      // 进度信息接口异常时初始化所有参数，并提示
      const errorFn = (thiz, msg) => {
        thiz.statusIndex = 1
        thiz.disabled = false
        thiz.$message.error(msg)
      }
      const thiz = this
      /**
       * 请求进度监控状态，定时触发回调
       */
      const fn = (delay, ...args) => {
        thiz.disabled = true
        thiz.statusIndex = 0
        setTimeout(async () => {
          // 如果请求次数超过60次，停止请求
          if (thiz.counter > 60 * 60) {
            errorFn(thiz, '请求超时')
          } else {
            thiz.counter++
            try {
              const { code, data } = await thiz.percentFn()
              if (code === 'SUCCESS') {
                thiz.percentage = data
                // 当进度不为100%，则重复请求
                if (thiz.percentage < 100) {
                  fn(delay, ...args)
                } else {
                  thiz.statusIndex = 2
                }
              } else {
                errorFn(thiz, '升级学年失败，请联系管理员')
              }
            } catch (error) {
              errorFn(thiz, '升级学年失败，请联系管理员')
            }
          }
        }, delay)
      }
      this.progressOn = fn
    }
  },
  methods: {
    dialogClose() {
      this.disabled = false
      this.counter = 0
      this.percentage = 0
      this.statusIndex = 0
    },
    // 确定按钮点击
    submit() {
      // 关闭对话框
      this.$emit('update:dialogVisible', false)
      // 对话框关闭之后的逻辑
      this.afterProgress()
    }
  },
  props: {
    dialogVisible: {
      type: Boolean
    },
    title: {
      type: String,
      default: '进度'
    },
    percentFn: {
      type: Function
    },
    afterProgress: {
      type: Function,
      default: () => {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/loading-dialog.vue